<mat-toolbar color="primary">
  <span id="møte-publiser-dialog-tittel">
    @if (type == 'møte') {
      {{ "Publiser {tittel} {nummer}"|translate: {tittel: moete().tittel, nummer: moete().nummer} }}
    } @else {
      {{ "Publiser protokoll fra {tittel} {nummer}"|translate: {tittel: moete().tittel, nummer: moete().nummer} }}
    }
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

@switch (modus()) {
  @case ('skjema') {
    <form [formGroup]="skjema" (ngSubmit)="publiser()">
      @if (laster()) {
        <mat-progress-bar mode="indeterminate"/>
      }
      <mat-dialog-content class="skjema">
        <tips>
          @if (type == 'møte') {
            <div>{{ 'Publiser møte slik at alle gruppemedlemmer kan lese innholdet.'|translate }}</div>
            <div>{{ 'Innholdet i et ikke-publisert møte er kun synlig for medlemmer med Administrator- eller "Tilgang til ikke-publisert informasjon"-rolle.'|translate }}</div>

          } @else {
            <div>{{ 'Publiser protokollen slik at alle gruppemedlemmer kan lese innholdet.'|translate }}</div>
            <div>{{ 'Innholdet i en ikke-publisert protokoll er kun synlig for medlemmer med Administrator- eller "Tilgang til ikke-publisert informasjon"-rolle.'|translate }}</div>
          }
        </tips>

        <mat-slide-toggle [formControl]="skjema.controls.sendMelding" data-testid="send-melding-felt">
          {{ 'Send melding til gruppemedlemmer'|translate }}
        </mat-slide-toggle>

        @if (skjema.value.sendMelding) {
          <fieldset>
            <mat-form-field>
              <mat-label>{{ 'Skriv inn beskjed inkludert i melding'|translate }}</mat-label>
              <riktekst-redigering [skjemakontroll]="skjema.controls.beskjed" [gruppeId]="moete().eiendeGruppeId" data-testid="beskjed"/>
            </mat-form-field>

            <mat-form-field>
              <mat-label>{{ 'Mottakere' | translate }}</mat-label>
              <mat-icon matPrefix fontSet="ion-ios-people-outline" class="mat-icon--ionic-ikon"/>
              <velg-medlemmer [skjemakontroll]="skjema.controls.valgteMottakere" [medlemmer]="tilgjengeligeMottakere"/>
            </mat-form-field>
          </fieldset>
        }
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <div>
          <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
          <button mat-raised-button color="primary" type="submit" cdkFocusInitial
                  [disabled]="skjema.invalid || lagrer()" [visSpinner]="lagrer()"
                  spinnerTekst="{{'Publiserer...'|translate}}" data-testid="publiser">
            {{ 'Publiser'|translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </form>
  }
  @case ('kvittering') {
    <mat-dialog-content class="kvittering">
      @if (this.skjema.value.sendMelding) {
        <p>
          @if (type == 'møte') {
            {{ 'E-post med informasjon om publisert møte har blitt sendt til {antall} medlemmer.'|translate: {antall: skjema.value.valgteMottakere.length} }}
            <br>
            {{ 'Alle gruppemedlemmer har nå tilgang til alle saksdetaljer.'|translate }}
          } @else {
            {{ 'E-post med informasjon om publisert protokoll har blitt sendt til {antall} medlemmer.'|translate: {antall: skjema.value.valgteMottakere.length} }}
            <br>
            {{ 'Alle gruppemedlemmer har nå tilgang til protokollen.'|translate }}
          }
        </p>
        <tips>
          {{ 'Du finner en oversikt over meldinger sendt til medlemmer i'|translate }}
          <a (click)="gaaTilHendelseslogg()">{{ 'møtets hendelseslogg'|translate }}</a>
        </tips>
        <melding-sendt-ikon/>
      } @else {
        <p>
          @if (type == 'møte') {
            {{ 'Møtet har blitt publisert.'|translate }}
            <br>
            {{ 'Alle gruppemedlemmer har nå tilgang til alle saksdetaljer.'|translate }}
          } @else {
            {{ 'Protokollen har blitt publisert.'|translate }}
            <br>
            {{ 'Alle gruppemedlemmer har nå tilgang til protokollen.'|translate }}
          }
        </p>
        <mat-icon>celebration</mat-icon>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <div>
        <button mat-raised-button color="primary" type="button" (click)="ferdig()" cdkFocusInitial data-testid="ferdig">
          {{ 'Lukk'|translate }}
        </button>
      </div>
    </mat-dialog-actions>
  }
}
